import { AddressesScreen, BalancesScreen, FeeTiersScreen, SettingsScreen } from './screenLibrary';

export const settingsMobileScreens = [{ ...SettingsScreen, path: '/' }];
export const addressesMobileScreens = [{ ...AddressesScreen, path: '/' }];
export const feeTiersMobileScreens = [{ ...FeeTiersScreen, path: '/' }];
export const balancesMobileScreens = [{ ...BalancesScreen, path: '/' }];
